import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEntrataLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45874_66565)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
			fill: "#E42127"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M27.7571 25.8224C26.1088 27.7898 23.3971 28.8851 20.7598 28.8851C15.6554 28.8851 11.8164 25.3652 11.8164 20.0162C11.8164 15.2626 15.0492 11.1152 20.1218 11.1152C24.8327 11.1152 28.1825 15.0925 28.1825 19.846C28.1825 20.3032 28.1506 20.7606 28.0762 21.1434H16.2509C16.4955 23.5361 18.4309 25.195 20.8555 25.195C22.791 25.195 24.333 24.0997 25.1518 23.2276L27.7571 25.8331V25.8224ZM23.5035 17.8042C23.3653 16.2941 21.9934 14.816 20.1218 14.816C18.2501 14.816 16.6763 16.2622 16.4636 17.8042H23.5035Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45874_66565",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgEntrataLogo;
